import { zodResolver } from "@hookform/resolvers/zod";
import { addHours, closestTo } from "date-fns";
import { useForm } from "react-hook-form";
import { t } from "ttag";

import { getTimeSlotOptions } from "@/shared/utils";
import { createSessionSchema, SESSION_FREQUENCY } from "../models";

const createSessionFormSchema = createSessionSchema
  .omit({ published: true })
  .refine(
    (data) => data.frequency === SESSION_FREQUENCY.ONE_TIME || data.endAt,
    {
      message: t`End date is required for recurring sessions`,
      path: ["endAt"],
    },
  );

const SESSION_HOURS_OFFSET = 1;
const defaultStartAt = addHours(new Date(), SESSION_HOURS_OFFSET);

export const useCreateSessionForm = () => {
  return useForm({
    resolver: zodResolver(createSessionFormSchema),
    defaultValues: {
      startAt: closestTo(
        defaultStartAt,
        getTimeSlotOptions(defaultStartAt).map((option) => option.value),
      ),
      frequency: SESSION_FREQUENCY.ONE_TIME,
    },
  });
};
